<template>
    <FormField :field="proxy_form.sale_code_form.fields.sale_codes" namespace="sale_codes" :name="'sale_codes'" class="mb-4" :disabled="!state.available_sale_codes_loaded || proxy_form.sale_code_form.fields.sale_codes.disabled" />
</template>

<script>
import {onBeforeMount, reactive, watch} from "vue"
import { useVehicleStore } from '@sto/vehicle.store'
import { useSaleStore } from '@sto/sale.store'
import { useAssetStore } from '@sto/asset.store'
import { useSystemStore } from '@sto/system.store'
import { useAuctioneerStore } from '@sto/auctioneer.store'
import { useAuthStore } from '@sto/auth.store'
import { isValid, getPayload, resetFieldset } from '@lib/helpers'

export default {
    props: ['asset', 'sale_section_id', 'sale_code_id', 'require_sale_section_id'],
    setup(props, {emit}) {

        const VEHICLE_STORE = useVehicleStore()
        const SYSTEM_STORE = useSystemStore()
        const AUTH_STORE = useAuthStore()
        const AUCTIONEER_STORE = useAuctioneerStore()
        const SALE_STORE = useSaleStore()
        const ASSET_STORE = useAssetStore()

        const state = reactive({
            available_sale_codes: [],
            available_sale_codes_loading: false,
            available_sale_codes_loaded: false,
            sale_code_update_modal_active: false,
            sale_code_update_loading: false
        })

        const proxy_form = reactive({
            sale_code_form: {
                fields: {
                    sale_codes: {
                        active: true,
                        label: 'Which sale codes?',
                        type: 'select',
                        value: [],
                        default_value: [],
                        stored_value: '',
                        options: [],
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: false,
                        disabled: true
                    }
                }
            }
        })

        /**
         * get the sale code ids for the scope organisation
         * @param {bool} refresh
         */
        const getAuctioneerSaleCodes = async (refresh = false) => {
            proxy_form.sale_code_form.fields.sale_codes.options_raw = []
            proxy_form.sale_code_form.fields.sale_codes.options = []
            proxy_form.sale_code_form.fields.sale_codes.value = null
            // we may need to disable this fetch if there is no sale section id yet
            if (props.require_sale_section_id && !props.sale_section_id) return;
            // we don't want to hit this unneccessarilt — sale codes are not gonna be changing frequently. no need to re-fetch during state mutation
            // likewise, stop if currently mid ffetch
            if ((state.available_sale_codes.length > 0 && !refresh) || state.available_sale_codes_loading === true) return

            try {
                state.available_sale_codes_loading = true
                const params = []
                if (props.sale_section_id) params.push({ key: 'sale_section_id', value: props.sale_section_id})
                const sale_codes = await AUCTIONEER_STORE.getSaleCodes(props.asset?.auctioneer_id, params)

                proxy_form.sale_code_form.fields.sale_codes.disabled = false
                proxy_form.sale_code_form.fields.sale_codes.options_raw = sale_codes
                proxy_form.sale_code_form.fields.sale_codes.options = sale_codes.map(({id, code, description}) => { return {value: id, label: `${code} (${description})`} })
                proxy_form.sale_code_form.fields.sale_codes.options.unshift({ value: null, label: 'Choose a Sale Code...'})

                proxy_form.sale_code_form.fields.sale_codes.value = props.sale_code_id
                    ? props.sale_code_id
                    : null

                checkFieldValidity()

            } catch (error) {
                console.error('SALE_STORE.getAuctioneerSaleCodes error', error)
            } finally {
                state.available_sale_codes_loading = false
                state.available_sale_codes_loaded = true
            }
        }

        const checkFieldValidity = () => {
            if (props.sale_section_id && !proxy_form.sale_code_form.fields.sale_codes.value) {
                proxy_form.sale_code_form.fields.sale_codes.pristine = false
                proxy_form.sale_code_form.fields.sale_codes.valid = false
            } else {
                proxy_form.sale_code_form.fields.sale_codes.pristine = true
                proxy_form.sale_code_form.fields.sale_codes.valid = true
            }
        }

        watch(
            () => props.sale_section_id,
            (new_value) => {
                getAuctioneerSaleCodes()
            }
        )

        watch(
            () => proxy_form.sale_code_form.fields.sale_codes.options_raw,
            (new_value) => {
                const new_options = new_value.filter(o => o.value !== null)
                if (new_options.length === 1) {
                    proxy_form.sale_code_form.fields.sale_codes.value = new_options[0].id
                }
            }
        )

        watch (
            () => proxy_form.sale_code_form.fields.sale_codes.value,
            (new_value) => {

                checkFieldValidity()

                if (new_value != props.sale_code_id) {
                    emit('sale_code_updated', new_value)
                }
            }
        )

        onBeforeMount(() => {
            getAuctioneerSaleCodes()
        })

        return {
            state,
            proxy_form
        }

    }
}
</script>